export default __webpack_public_path__ + "static/media/gravit8_logo.200ad770.svg";